import PropTypes from 'prop-types';
import StakeTaxImpl from './stake-tax-info.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Component to display stake tax info of bet funds.
 *
 * @class StakeTaxInfo
 * @memberof Mojito.Presentation.Components.BetFunds
 */

/**
 * StakeTaxInfo props.
 *
 * @property {number} value - Stake tax value.
 * @property {boolean} [hasDivider] - Flag to append $BET_FUNDS.DIVIDER to label.
 * @property {string} currencyCode - Currency.
 * @property {string} [class] - Class name assigned to the root element.
 * @property {string} [testId] - Testing identifier rendered as data-testid on the root element.
 *
 * @memberof Mojito.Presentation.Components.BetFunds.StakeTaxInfo
 */
const propTypes = {
    value: PropTypes.number.isRequired,
    hasDivider: PropTypes.bool,
    currencyCode: PropTypes.string.isRequired,
    class: PropTypes.string,
    testId: PropTypes.string,
};

export default UIView('StakeTaxInfo', StakeTaxImpl, propTypes);
